import { Box, Grid, Stack } from "@mui/material";

import SponsorLogos from "../../app/SponsorLogos";

function getLogoSourceByName(name) {
  switch (name) {
    case "vtc":
      return "/vtc_logo.png";
    case "bfcf":  // 鵬程
      return "/bfcf_badge.png";
    case "thei":
      return "/thei_logo.png";
    case "hsta":
      return "/hsta_logo.png";
    case "marriott":
      // return "/marriott_logo.png";
      return "/marriott_logo_2.jpeg"
    default:
      return "";
  }
}

function getDynamicLogoBlock(logoListStr) {
  var logoList = logoListStr.split(",");

  // Trim whitespace and filter out empty strings
  logoList = logoList.map(logo => logo.trim()).filter(logo => logo !== "");


  return (
    < Stack direction="row" spacing={2} justifyContent="center" alignItems="center" >
      {
        logoList.map((logo, index) => {
          let logoSrc = getLogoSourceByName(logo);
          if (logoSrc) {
            return (
              <Box
                key={index}
                component={"img"}
                src={logoSrc}
                sx={{ objectFit: "contain", height: "40px" }}
              />
            );
          }
          return null; // Skip if no valid logo source
        })
      }
    </Stack >)
}
function getSponsorComponentByName(name) {
  // default: --> <SponsorLogos />
  // "" --> Nothing 
  switch (name) {
    case "sponsor1":
      return <SponsorLogos />;
    default:
      return getDynamicLogoBlock(name);
  }
}

export default function Footer({ leftLogo = "", rightLogo = "bfcf", sponsor = "sponsor1" }) {
  let leftLogoSrc = getLogoSourceByName(leftLogo);
  let rightLogoSrc = getLogoSourceByName(rightLogo);
  let sponsorBlock = getSponsorComponentByName(sponsor);

  console.log("Footer props:", leftLogo, rightLogo, sponsor);
  console.log("Footer logos:", leftLogoSrc, rightLogoSrc, sponsorBlock);

  let logoHeight = 40; // Default height for logos

  return (
    <Box
      position={"fixed"}
      bottom={0}
      zIndex={10}
      width={"100vw"}
      height={"70px"}
      bgcolor="white"
    >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        py={2}
        px={3}
      >
        {
          leftLogoSrc ?
            <Box
              component={"img"}
              src={leftLogoSrc}
              sx={{ objectFit: "contain", height: logoHeight, objectPosition: "left" }}
            />
            :
            <Box sx={{ width: "200px", height: logoHeight, }} /> // Placeholder if no logo
        }

        {sponsorBlock}

        {
          rightLogoSrc ?
            <Box
              component={"img"}
              src={rightLogoSrc}
              sx={{ objectFit: "contain", width: "200px", height: logoHeight, objectPosition: "right" }}
            />
            :
            <Box sx={{ width: "200px", height: logoHeight }} /> // Placeholder if no logo
        }
      </Grid>
    </Box>
  );
}
